import {Divider, Menu} from '@mui/material'
import React from 'react'
import MenuItem from './MenuItem'
import {itemMenus} from 'constants/toolbar'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {useLogoutMutation} from 'store/Store'
import baseApi from 'store/slices/api/baseApi'
import SettingsIcon from '@mui/icons-material/Settings'
import LogoutIcon from '@mui/icons-material/Logout'
import {useAuthorization} from 'logic/useAuthorization'

const MobileMenu = ({
    mobileMoreAnchorEl,
    isMobileMenuOpen,
    handleMobileMenuClose,
}) => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [doLogout] = useLogoutMutation()
    const {isSuper} = useAuthorization()

    const handleSettings = () => {
        handleMobileMenuClose()
        navigate('/settings')
    }

    const handleLogout = async () => {
        handleMobileMenuClose()
        await doLogout().unwrap()
        dispatch(baseApi.util.resetApiState())
        navigate('/login', {replace: true})
    }

    return (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
            transformOrigin={{vertical: 'top', horizontal: 'right'}}
            keepMounted
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}>
            {/* Other icon menu items except profile */}
            {Object.values(itemMenus)
                .filter((item) => item.title !== 'menuItems.profile')
                .filter((item) => !item.superUserOnly || isSuper())
                .map((item, index) => (
                    <MenuItem
                        key={index}
                        icon={item?.icon}
                        title={t(item?.title)}
                        badgeColor={item?.badgeColor}
                        badgeContent={item?.badgeContent}
                        onClick={item?.onClick}
                    />
                ))}
            <Divider />
            <MenuItem
                icon={<SettingsIcon fontSize="small" />}
                title={t('header.profile.settings')}
                onClick={handleSettings}
            />
            <MenuItem
                icon={<LogoutIcon fontSize="small" />}
                title={t('header.profile.logout')}
                onClick={handleLogout}
            />
        </Menu>
    )
}

export default MobileMenu
